/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import { optionsFlagged } from "../../../../../actions/Layers/constants";
import useConfig from "../../../../../actions/Tenants/config/configHook";
import { usePatchCheckMutation } from "../../../../../hooks/mutations";
import { usePatchCheckStateLocally } from "../../../../../hooks/mutations/usePatchCheckMutation";
import { getFilledArrayOrDefault } from "../../../../../utils/getFilledArrayOrDefault";
import MetaForm from "../../../../Forms/MetaForm";
import { Loading } from "../../../../Helper/Loading";

const defaultFormFields = [
    {
        label: "Notes",
        name: "feedback",
        type: "textarea",
        lg: 12,
    },
    {
        label: "",
        name: "flag",
        type: "radio",
        options: optionsFlagged,
        lg: 12
    }
];

export default function CheckSummaryForm({ layer, check }) {
    const config = useConfig();
    const location = config.get_check_type_config(layer, check);
    const patchCheckStateLocally = usePatchCheckStateLocally();
    const patchCheckMutation = usePatchCheckMutation();
    const setCheckValue = (field, value, callApi) => {
        patchCheckStateLocally(check, { [field]: value });
        if (callApi) {
            patchCheckMutation.mutate({ check, field, value });
        }
    };

    // when you navigate from a parent layer to a child layer check summary...
    // we need to give it some time to reinstate the config (e.g. when the parent doesn't have a location)
    if (!layer || !check || !location || !location.summary_fruit_fields) {
        return <Loading />;
    }

    // * we use this to copy data from the layer to the check e.g. yield_intake,
    // * or from a computed check_meta value (e.g. the ripening decision proposal).
    const meta_form = getFilledArrayOrDefault(location.meta_form_summary).map((field) => {
        let mapped = field;
        if (layer[field.default_value_from_layer_key] !== undefined) {
            mapped = { ...mapped, default_value: layer[field.default_value_from_layer_key] };
        }
        if (field.default_value_from_check_meta && check[field.default_value_from_check_meta] !== undefined) {
            mapped = { ...mapped, default_value: check[field.default_value_from_check_meta] };
        }
        return mapped;
    });

    return (
        <div className="d-print-none pt-3">
            {meta_form && <MetaForm
                grid={true}
                meta={[...getFilledArrayOrDefault(meta_form), ...defaultFormFields]}
                onDebounce={(field, value) => setCheckValue(field, value, true)}
                setValue={(field, value) => setCheckValue(field, value, false)}
                object={check}
                config={config} />}
        </div>
    );
}


CheckSummaryForm.propTypes = {
    check: PropTypes.object,
    layer: PropTypes.object,
};
